import React from 'react';
import { useRive, Layout, Fit, Alignment } from '@rive-app/react-canvas';
import { t } from '../i18n';
import './LoadingRive.css';

const logo = `${process.env.PUBLIC_URL}/logo.svg`;

interface LoadingRiveProps {
  animation?: 'LogoFillingLoader';
  loop?: boolean;
  className?: string;
  label?: string;
}

const LoadingRive: React.FC<LoadingRiveProps> = ({
  animation = 'LogoFillingLoader',
  loop = true,
  className = '',
  label = t('common.loading')
}) => {
  const { RiveComponent } = useRive({
    // Use public assets path: placed in public/assets/animations
    src: `${process.env.PUBLIC_URL}/assets/animations/${animation}.riv`,
    autoplay: true,
    layout: new Layout({ fit: Fit.Contain, alignment: Alignment.Center }),
  });

  // Reduced motion fallback
  const prefersReducedMotion = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return (
    <div className={`rive-loader-wrapper ${className}`} aria-label={label} role="status">
      {prefersReducedMotion ? (
        <img src={logo} alt={t('common.loadingAlt')} className="rive-loader-fallback" />
      ) : (
        <RiveComponent />
      )}
      <p className="rive-loader-text">{label}</p>
    </div>
  );
};

export default LoadingRive;
